import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/overlook-studios',
  routes: [
    {
      path: '/',
      component: () => import('./views/studio/'),
      children: [
        {
          path: '',
          redirect: 'about'
        },
        {
          path: 'games',
          name: "games",
          component: () => import('./views/studio/games.vue')
        },
        {
          path: 'about',
          name: "about",
          component: () => import('./views/studio/about.vue')
        },
      ]
    },
    {
      path: '/games/project-synthecite',
      name: 'main',
      component: () => import('./views/project-synthecite/main.vue')
    }
  ]
})
